<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
const DEBUG_UNLOCK_CODE = 'hhyt888'
const DEBUG_UNLOCK_STORAGE_KEY = 'debugUnlocked'
// 临时测试：开发环境也走口令验证，测完改回 false
const FORCE_DEBUG_PASSWORD = false

export default {
  name: 'App',
  data() {
    return {
      debugUnlocked: localStorage.getItem(DEBUG_UNLOCK_STORAGE_KEY) === '1'
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleF12Key)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleF12Key)
  },
  methods: {
    handleF12Key(e) {
      if (e.key !== 'F12' && e.keyCode !== 123) return

      const requirePassword = process.env.NODE_ENV === 'production' || FORCE_DEBUG_PASSWORD

      // 无需口令：不拦截，F12 由浏览器正常打开 DevTools
      if (!requirePassword) return

      // 生产环境已解锁：不拦截，F12 正常打开 DevTools
      if (this.debugUnlocked) return

      // 生产环境未解锁：拦截 F12，弹出口令框
      e.preventDefault()
      e.stopPropagation()

      this.$prompt('请输入调试口令', '调试模式', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        closeOnClickModal: false
      }).then(({ value }) => {
        if (value === DEBUG_UNLOCK_CODE) {
          this.debugUnlocked = true
          localStorage.setItem(DEBUG_UNLOCK_STORAGE_KEY, '1')
          this.$message.success('验证通过，请再次按 F12 打开开发者工具')
        } else {
          this.$message.error('口令错误')
        }
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background: #f8fafc;
}
body{
  margin: unset;
  cursor: pointer;
}
.el-input:focus-within:hover .el-input__inner,
.el-input:hover .el-input__inner,
.el-textarea:focus-within:hover .el-textarea__inner,
.el-textarea:hover .el-textarea__inner {
  color: transparent !important;
  text-shadow: 0 0 0 #303133 !important;
  caret-color: #1890ff !important;
  -webkit-caret-color: #1890ff !important;
}
</style>
<style>
::v-deep .el-input__inner {
  caret-color: #000000;
  color: #000000;
}
::v-deep input {
  caret-color: #000000;
  cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='22'%3E%3Cpath d='M3 0 L3 22' stroke='%23303133' stroke-width='2' fill='none'/%3E%3C/svg%3E") 3 11, text !important;
  color: #000000;
}
.el-input__inner,
.el-textarea__inner {
  color: #000000;
  caret-color: #000000;
}
input,
.el-input__inner,
.el-textarea__inner,
.el-select .el-input__inner,
.el-date-editor .el-input__inner {
  cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='22'%3E%3Cpath d='M3 0 L3 22' stroke='%23303133' stroke-width='2' fill='none'/%3E%3C/svg%3E") 3 11, text !important;
}
</style>
